import React from "react";
// import { VscFilePdf } from "react-icons/vsc";
// import { BsPersonSquare } from "react-icons/bs";
// import { GiFilmProjector, GiGearHammer, GiSkills } from "react-icons/gi";
// import { AiOutlineFundProjectionScreen } from "react-icons/ai";
// import { RiHome2Fill, RiHomeGearFill, RiMedalLine } from "react-icons/ri";
// import { BsInfoSquare } from "react-icons/bs";
import { Link, NavLink, Outlet } from "react-router-dom";
import Card from "../Components/UI/Card";
import { ImHome, ImStatsBars, ImTrophy } from "react-icons/im";

const SideBar = ({ onClickHome, onClickOther }) => {
  return (
    <>
      {/* <aside
        // id="logo-sidebar"
        className="absolute top-0 left-0 z-40 w-64 min-h-[calc(100vh)] h-full pt-16 transition duration-200 -translate-x-full shadow-lg md:block md:translate-x-0 bg-slate-800"
        // aria-label="Sidebar"
      > */}
      <aside
        id="logo-sidebar"
        className="fixed md:top-0 md:left-18 bottom-0 border-t-2 border-cyan-400 md:border-none  w-full h-16  z-40 md:w-64 md:min-h-[calc(100vh)] md:h-full md:pt-16 transition duration-200  shadow-lg  md:translate-x-0 bg-gray-900  "
        aria-label="Sidebar"
      >
        <div className="p-2 md:p-4  md:text-[#c8c8c8]  w-full h-14   ">
          {/* <div className="inline-block p-2 "> */}
          <div className="hidden w-full pb-2 m-auto md:inline-block ">
            <Card
              tiltEnable="true"
              // glareEnable="true"
              // glareMaxOpacity={0.4}
              // glareColor="#ffffff"
              // perspective={500}
            >
              <div className="flex flex-col items-center h-full p-2 bg-slate-700 hover:z-10">
                <div className="flex justify-center w-20 h-20 rounded-full bg-slate-400 ">
                  <img
                    src={require("../Assets/img/UI/face.png")}
                    alt="profile pic"
                    className="h-20 p-2"
                  />
                </div>
                <h2 className="text-2xl ">Mansoor Khan</h2>
                <p className="text-sm">Frontend Developer</p>
                <p className="text-xs text-blue-400">
                  # Learner # Open to Work
                </p>
              </div>
            </Card>
          </div>

          <ul className="flex items-center justify-between w-full m-auto md:inline-block">
            <li
              className="duration-200 ease-in-out md:mb-2 md:hover:bg-gray-700 "
              onClick={onClickHome}
            >
              <NavLink
                to="/"
                href="#"
                className="flex items-center p-2 text-base font-normal text-gray-300 duration-500 md:focus:border-l-8 md:focus:border-violet-700 focus:border-b-8 focus:border-violet-800 md:focus:border-b-0 "
              >
                <ImHome className="w-4 h-4 sm:w-6 sm:h-6 " />
                <span className="ml-3">Home</span>
              </NavLink>
            </li>
            <li
              className="duration-200 ease-in-out md:mb-2 md:hover:bg-gray-700"
              onClick={onClickOther}
            >
              <NavLink
                to="/skills"
                className="flex items-center p-2 text-base font-normal text-gray-300 duration-500 md:focus:border-l-8 md:focus:border-violet-700 focus:border-b-8 focus:border-violet-800 md:focus:border-b-0 "
              >
                <ImStatsBars className="w-4 h-4 sm:w-6 sm:h-6 " />
                <span className="flex-1 ml-3 whitespace-nowrap">Skills</span>
              </NavLink>
            </li>
            <li
              className="duration-200 ease-in-out md:mb-2 md:hover:bg-gray-700"
              onClick={onClickOther}
            >
              <NavLink
                to="/project"
                className="flex items-center p-2 text-base font-normal text-gray-300 duration-500 md:focus:border-l-8 md:focus:border-violet-700 focus:border-b-8 focus:border-violet-800 md:focus:border-b-0 "
              >
                <ImTrophy className="w-4 h-4 sm:w-6 sm:h-6 " />
                <span className="flex-1 ml-3 whitespace-nowrap">Project</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside>

      <div className="col-start-1 col-end-3 row-start-1 row-end-2 md:col-end-3 pb-16 md:pb-0 md:col-start-2 justify-self-center md:pt-[4rem]">
        <Outlet />
      </div>
    </>
  );
};

export default SideBar;
